/**
 * Rail de flux PERSISTANT — monté une seule fois dans AppShell, il répond en permanence
 * à « où suis-je dans le cycle et où aller ensuite » sur les écrans de flux. L'étape
 * courante est déduite du chemin (source unique `@/lib/lifecycle`) ; hors des routes de
 * flux, le rail ne s'affiche pas (retourne null), donc aucun bruit sur les autres écrans.
 *
 * Les ÉTAPES, elles, viennent du template de l'espace actif quand il en déclare — c'est ici
 * que le cycle de vie configurable devient visible. Un espace sans template, ou dont le
 * template n'en déclare pas, garde le cycle intégré : le rail est identique à ce qu'il était.
 */
import type { JSX } from 'react'
import { useLocation } from 'react-router-dom'

import { LifecycleRail } from '@/components/LifecycleRail'
import { lifecycleStepFromPath } from '@/lib/lifecycle'
import { useEffectiveTemplate } from '@/hooks/useEffectiveTemplate'

export function WorkflowRail(): JSX.Element | null {
  const { pathname } = useLocation()
  const { lifecycle } = useEffectiveTemplate()
  const step = lifecycleStepFromPath(pathname)
  if (!step) return null
  return (
    <div className="border-b bg-muted/30 px-4 py-2 sm:px-6" data-testid="workflow-rail">
      <LifecycleRail current={step} etapes={lifecycle} />
    </div>
  )
}
